<template>
  <div>Dashboard</div>
</template>

<script>
export default {
  name: "dashboard",
  mounted() {
    document.title = "Dashboard | magardTELE";
  },
};
</script>